import React, { useState } from 'react';
import { Card, Form, Tag, Button } from 'antd';
import ServicePolicyModal from './ServicePolicyModal';
import WeekdayCancelRules from 'components/base/SPCancelRules/Weekday';
import HolidayCancelRules from 'components/base/SPCancelRules/Holiday';

const OtherInfo:React.FC<any> = (props) => {
  const { data } = props || {};

  const { snapshot } = data?.order_info || {};

  const [visible, setVisible] = useState(false);

  const handleCancel = () => {
    setVisible(false);
  };

  const getContainText = (isContain: any) => {
    return isContain === 1 ? '包含' : '不包含';
  }

  return (
    <>
      <Card title="其他信息" style={{ marginBottom: 20 }}>
        <Form.Item
          label="服务标签"
          name="username"
        >
          <>
            {(snapshot?.tags || []).map((item: any, index: number) => {
              return (
                <Tag color="magenta" key={index}>{item}</Tag>
              );
            })}
          </>
        </Form.Item>
        <Form.Item
          label="服务保障"
          name="username"
        >
          <div style={{ marginTop: 4 }}>
            <h5>{snapshot?.guarantee_detail?.name}</h5>
            <p>理赔范围内，{ snapshot?.guarantee_detail?.guarantee_deductible_amount / 100 } 元以上车辆损失免赔（{getContainText(snapshot?.guarantee_detail?.contains_glass_loss)}玻璃损失、{getContainText(snapshot?.guarantee_detail?.contains_tyres_loss)}轮胎损失）</p>
            <p>第三方保障{snapshot?.guarantee_detail?.third_amount / 1000000}万</p>
            <p>折旧费：{ snapshot?.guarantee_detail?.depreciate?.used === 1 ? `${snapshot?.guarantee_detail?.depreciate?.amount / 100 }以下，您无需承担车辆折旧费，在${snapshot?.guarantee_detail?.depreciate?.amount / 100 }元以上收维修费的${snapshot?.guarantee_detail?.depreciate?.percent}%作为折旧费` : '不收取' }</p>
            <p>停运费：{ snapshot?.guarantee_detail?.outage?.used === 1 ? `对于因车辆事故，或因驾车过程中操作不当造成的车辆故障等影响车辆正常营运，将收取停运损失费，根据车辆所需维修时段，按维修时段实时费用（包含基本保险，但不包含手续费及附加服务费）的${snapshot?.guarantee_detail?.outage?.percent}%收取车辆停运损失费` : '不收取' }</p>
          </div>
          {snapshot?.appreciation_detail && <div style={{ marginTop: 4 }}>
            <h5>{snapshot?.appreciation_detail?.name}</h5>
            <p>理赔范围内，{ snapshot?.appreciation_detail?.guarantee_deductible_amount / 100 } 元以上车辆损失免赔（{getContainText(snapshot?.appreciation_detail?.contains_glass_loss)}玻璃损失、{getContainText(snapshot?.appreciation_detail?.contains_tyres_loss)}轮胎损失）</p>
            <p>第三方保障{snapshot?.appreciation_detail?.third_amount / 1000000}万</p>
            <p>折旧费：{ snapshot?.appreciation_detail?.depreciate?.used === 1 ? `${snapshot?.appreciation_detail?.depreciate?.amount / 100 }以下，您无需承担车辆折旧费，在${snapshot?.appreciation_detail?.depreciate?.amount / 100 }元以上收维修费的${snapshot?.appreciation_detail?.depreciate?.percent}%作为折旧费` : '不收取' }</p>
            <p>停运费：{ snapshot?.appreciation_detail?.outage?.used === 1 ? `对于因车辆事故，或因驾车过程中操作不当造成的车辆故障等影响车辆正常营运，将收取停运损失费，根据车辆所需维修时段，按维修时段实时费用（包含基本保险，但不包含手续费及附加服务费）的${snapshot?.appreciation_detail?.outage?.percent}%收取车辆停运损失费` : '不收取' }</p>
          </div>}
          {/* appreciation_detail */}
        </Form.Item>
        <Form.Item
          label="取消规则"
          name="username"
        >
          <div style={{ marginTop: 6 }}>
            {((snapshot?.cancel_rule || [])).map((item: any) => {
              if (!item.from && item.to) {
                return (<p>取车前 {item.to}前：免费取消</p>);
              }
              if (item.from && item.to) {
                return (<p>取车时间在 {item.from} 至 {item.to}： 按照订单总金额收取 {item.percent}% 作为违约金</p>);
              }
              if (item.from && !item.to) {
                return (<p>超过取车时间 {item.from}后：按照订单总金额收取 {item.percent}% 作为违约金</p>);
              }
              return '';
            })}
          </div>
        </Form.Item>
        <Form.Item
          label="服务政策"
          name="username"
        >
          <Button type="link" disabled={false} onClick={() => setVisible(true)}>查看详情&gt;</Button>
        </Form.Item>
      </Card>
      <ServicePolicyModal visible={visible} policy={snapshot?.claim_policy} onCancel={handleCancel} />
    </>
  );
}

export default OtherInfo;
